import React, { Component } from 'react';
import AriaModal from 'react-aria-modal';

import './modal.css';
class SaveCurrentFileModal extends Component {

	constructor() {
		super();

		this.state = {
			showModal: false
		}

		this.activateModal = this.activateModal.bind(this);
		this.deactivateModal = this.deactivateModal.bind(this);
		this.confirmModal = this.confirmModal.bind(this);
		this.reject = this.reject.bind(this);
	}

	deactivateModal() {
		this.setState({
			showModal: false
		})
	}
	reject() {
		this.setState({
			showModal: false
		});
		if (this.props.onCancel) {
			this.props.onCancel();
		}
	}
	confirmModal() {
		this.setState({
			showModal: false
		});

		const data = {
			name: this.props.name,
			path: this.props.path,
			service: this.props.service
		};

		if (this.props.onClick) {
			this.props.onClick(data);
		}
	}
	activateModal() {
		this.setState({
			showModal: true
		});
	}

	_renderModal() {
		return <AriaModal
          titleText="Overwrite File"
          onExit={this.deactivateModal}
          underlayStyle={{ paddingTop: '2em' }}
        >
          <div className="modal">
            <div className="modal-body">
            	<p>{this.props.name} has been modified. Save changes?</p>
            </div>
            <footer className="modal-footer">
            	<button className='btn' onClick={this.deactivateModal}>
                Cancel
              </button>
              <button className='btn' onClick={this.reject}>
                No
              </button>
              <button className='btn' onClick={this.confirmModal}>
                Yes
              </button>
            </footer>
          </div>
        </AriaModal>
	}

	render() {
		return <div>{this.state.showModal ? this._renderModal() : null}</div>
	}
}

export default SaveCurrentFileModal;


// WEBPACK FOOTER //
// ./src/components/save-current-file-modal.js